import React from 'react';
import { useTranslation } from 'react-i18next';

import { Text, TextProps } from '@/components/TextComponent';

type PolymarketDisclaimerProps = {
    textAlign?: TextProps['textAlign'];
};

/** Polymarket US attribution shown under Predictions entry lists (betslip, Trades footer). */
export const PolymarketDisclaimer = ({ textAlign = 'center' }: PolymarketDisclaimerProps) => {
    const { t } = useTranslation('betslip_sbk');

    return (
        <Text variant="bodySmall" color="neutral400" textAlign={textAlign} letterSpacing={-0.08}>
            {t('polymarket_disclaimer')}
        </Text>
    );
};

export const PolymarketConfirmationDisclaimer = () => {
    const { t } = useTranslation('betslip_sbk');

    return (
        <Text variant="bodySmall" textAlign="center" letterSpacing={-0.08}>
            {`${t('polymarket_disclaimer')} ${t('values_subject_to_change')}`}
        </Text>
    );
};
